<script lang="ts" setup>
const props = defineProps({
  companiesPerPage: {
    default: 25,
    type: Number,
  },
  currentPage: {
    default: 1,
    type: Number,
  },
  loading: {
    default: false,
    type: Boolean,
  },
  totalCompanies: {
    default: 0,
    type: Number,
  },
})

const { t } = useI18n()

const displayRange = computed(() => {
  const endValue = props.currentPage * props.companiesPerPage

  return endValue < props.totalCompanies ? ` - ${numbro(endValue)}` : ''
})

const displayStart = computed(() => {
  return numbro((props.currentPage - 1 > 0 ? props.currentPage - 1 : 0) * props.companiesPerPage || 1)
})

const isMultiplePages = computed(() => {
  return props.totalCompanies > props.companiesPerPage
})
</script>

<template>
  <UButton
    class="gradient-texture-reverse pointer-events-none text-xs uppercase"
    size="md"
  >
    <UIcon
      class="mr-0.5 size-5 flex-shrink-0"
      :class="{ 'animate-reverse-spin': loading }"
      :name="getIcon(loading ? 'loading' : 'companies')"
    />

    <template v-if="loading">
      {{ t('globals.loading') }}
    </template>

    <template v-else-if="!totalCompanies">
      {{ t('noCompanies') }}
    </template>

    <template v-else>
      <span
        v-if="isMultiplePages"
        class="-mr-1"
      >
        {{ displayStart }} {{ displayRange }} /
      </span>

      {{ numbro(totalCompanies) }}
      <span class="hidden sm:inline">
        {{ t('globals.company', totalCompanies) }}
      </span>
    </template>
  </UButton>
</template>

<i18n lang="json">
{
  "en": {
    "noCompanies": "No companies"
  },
  "es": {
    "noCompanies": "No hay empresas"
  },
  "fr": {
    "noCompanies": "Aucune entreprise"
  }
}
</i18n>
